import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const BlogTeaser: React.FC = () => {
  const { t } = useTranslation('home');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const posts = t('blogTeaser.posts', { returnObjects: true }) as Array<{
    title: string;
    excerpt: string;
    date: string;
    category: string;
  }>;

  return (
    <section className="py-20 section-dark" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 gradient-text">
            {t('blogTeaser.title')}
          </h2>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            {t('blogTeaser.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((post, index) => (
            <motion.article
              key={index}
              className="card p-6 hover:border-primary-500 transition-all duration-300 cursor-pointer"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.03 }}
            >
              <div className="text-primary-500 text-sm font-medium mb-2">
                {post.category} • {post.date}
              </div>
              <h3 className="text-xl font-bold mb-3">{post.title}</h3>
              <p className="text-secondary mb-4">{post.excerpt}</p>
              <button className="text-primary-500 font-medium hover:underline">
                {t('blogTeaser.readMore')} →
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogTeaser;
